import { render, staticRenderFns } from "./HistoryEmptyDefaultLayout.vue?vue&type=template&id=b7ccccb6&scoped=true"
import script from "./HistoryEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./HistoryEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ccccb6",
  null
  
)

export default component.exports